// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/metrics/metrics.scss
// module id = 984
// module chunks = 0